import * as React from 'react';

import { calculateTotal } from '../../../providers/TransactionsProvider';
import { toCurrency } from '../../../utils/formatting';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface ITotalRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  value?: number;
  valueClassName?: string;
  colored?: boolean;
  showSign?: boolean;
  negateAmount?: boolean;
}

const TotalRow = ({
  transactions,
  dateRange,
  value: valueOverride,
  valueClassName: valueClassNameOverride,
  colored = false,
  showSign = false,
  negateAmount = false,
}: ITotalRowProps) => {
  const calculatedValue = React.useMemo(() => calculateTotal(transactions, dateRange), [transactions, dateRange]);

  const rawValue = valueOverride !== undefined ? valueOverride : calculatedValue;
  const value = negateAmount ? -rawValue : rawValue;

  const valueClassName = React.useMemo(() => {
    if (valueClassNameOverride) {
      return valueClassNameOverride;
    }
    if (colored) {
      return value >= 0 ? 'text-success-primary' : 'text-error-primary';
    }
    return '';
  }, [valueClassNameOverride, colored, value]);

  const formattedValue = toCurrency(value, { showSign });

  return <Widget.Row label="Total" value={formattedValue} valueClassName={valueClassName} />;
};

export default TotalRow;
